module.exports = __webpack_public_path__ + "media/uprising.3b4047db.mp3";